/**
 * ULD外放管理 API 模块
 * 提供ULD外放给收货人的相关API接口
 */

import apiClient from "./axios";

export const uldDeliveryApi = {
    // 单个ULD外放
    deliverToConsignee: ({ id, data }) => 
        apiClient.post(`/v1/uld/${id}/deliver`, data),

    // 撤销单个ULD外放
    revokeDelivery: ({ id, data }) => 
        apiClient.post(`/v1/uld/${id}/revoke-delivery`, data),

    // 批量ULD外放
    batchDeliverToConsignee: (data) => 
        apiClient.post("/v1/uld/batch/deliver", data),

    // 批量撤销ULD外放
    batchRevokeDelivery: (data) => 
        apiClient.post("/v1/uld/batch/revoke-delivery", data),
}; 